import { getDateString } from 'owa-datetime';
import { setGoalDateProperties } from './setGoalDateProperties';
import { updateCalendarEvent } from 'owa-timestream-asset-sdk-calendarevents';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { logSpacesDatapoint } from 'owa-timestream-logging';

export default function updateGoalEvent(
    event: Readonly<CalendarEvent> | null,
    title: string | undefined,
    date: string | undefined,
    tz: string | undefined
) {
    if (event) {
        const updates = {} as Partial<CalendarEvent>;

        if (title !== undefined && event.Subject != title) {
            updates.Subject = title;
        }

        if (date !== undefined && tz !== undefined) {
            if (
                getDateString(event.Start) != date ||
                event.StartTimeZoneId != tz ||
                !event.IsAllDayEvent
            ) {
                setGoalDateProperties(updates, date, tz);
            }
        }

        if (Object.keys(updates).length) {
            logSpacesDatapoint('OUTLOOKSPACES_GOAL_UPDATE_EVENT');
            updateCalendarEvent('SpacesGoalAsset', event, updates).catch(onUpdateGoalEventFailed);
        }
    }
}

function onUpdateGoalEventFailed() {
    logSpacesDatapoint('OUTLOOKSPACES_GOAL_UPDATE_EVENT_FAILED');
}
